import { RecordPointer, RecordTable, tablePropsMap } from "libs/schema";
import { ADMIN_USER_ID } from "libs/shared-constants";
import { PermissionError } from "libs/errors";
import { ActionServerContext } from "../action";

type TableWithUserId = {
  [K in RecordTable]: (typeof tablePropsMap)[K] extends { user_id: true } ? K : never;
}[RecordTable];

export async function authorizeUserOwnership<T extends TableWithUserId>(
  pointer: RecordPointer<T>,
  context: ActionServerContext,
  options?: { includeSoftDeletes?: boolean; ignoreMissingRecord?: boolean },
) {
  const { includeSoftDeletes, ignoreMissingRecord } = options || {};

  const [record] = await context.environment.db.getRecord(pointer, {
    includeSoftDeletes,
    currentUserId: ADMIN_USER_ID,
  });

  if (!record) {
    if (ignoreMissingRecord) {
      return;
    } else {
      throw new PermissionError(`Record ${pointer.table}:${pointer.id} does not exist`);
    }
  }

  if (record.user_id !== context.currentUserId) {
    throw new PermissionError(`User doesn't have ownership of ${pointer.table}:${pointer.id}`);
  }
}
